// Copyright (c) 2017 Deere & Company

import ClaimRecordInfo, {getDefaultState as getRecordInfo} from './claim-record-info';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import PipIndicator, {getDefaultState as getPipIndicatorDefaultState} from './pip-indicator';
import t from 'tcomb';

const ClaimForApprovalSummary = t.struct({
    claimCurrency: KeyValuePair,
    claimNumber: t.String,
    claimType: t.String,
    claimTypeDescription: t.String,
    companyContribution: t.Number,
    customerContribution: t.Number,
    dealerContribution: t.Number,
    openPipCount: t.Number,
    pin: t.String,
    pipIndicator: PipIndicator,
    recordInfo: ClaimRecordInfo,
    reference1: t.String,
    responsibleAccount: Dealer,
    specialAllowanceType: KeyValuePair,
    status: KeyValuePair,
    submittedDate: t.maybe(t.Number),
    territory: t.String
}, {
    name: 'ClaimForApprovalSummary',
    strict: true
});

export const getDefaultState = () => new ClaimForApprovalSummary({
    claimCurrency: getKeyValuePairDefaultState(),
    claimNumber: '',
    claimType: '',
    claimTypeDescription: '',
    companyContribution: 0,
    customerContribution: 0,
    dealerContribution: 0,
    openPipCount: 0,
    pipIndicator: getPipIndicatorDefaultState(),
    recordInfo: getRecordInfo(),
    reference1: '',
    responsibleAccount: getDealerDefaultState(),
    specialAllowanceType: getKeyValuePairDefaultState(),
    status: getKeyValuePairDefaultState(),
    submittedDate: null,
    territory: t.String
});

export default ClaimForApprovalSummary;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-for-approval-summary.js